import Vue from "vue";
import App from "./App";
import router from "./router";
import Vuetify from "vuetify";
import Vuelidate from "vuelidate";
import VueGoodTable from 'vue-good-table';

// import the styles 

import "vuetify/dist/vuetify.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import 'vue-good-table/dist/vue-good-table.css'
import VueLocalForage from "vue-localforage";
import money from 'v-money'
import VueFire from 'vuefire'

Vue.use(VueFire)
Vue.use(VueLocalForage);
//Vue.use(Vuetify)


Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(VueGoodTable);

Vue.use(money, {
  precision: 4
})

Vue.use(Vuetify, {
  theme: {
    primary: "#F69F00", //    "#932C28",
    secondary: "#F69F00", //    "#0097e6",
    terciary: "#E20612",
    carregando: "#EA9F12",
    acent2: "#932C28",
    errror: "#F50057",
    info: "#80D8FF",
    sucesso: "#00C853",
    card: '#E3E3E3'
  }
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js